import styled, { css } from "styled-components";
import { colors } from "utils";

// Figma colors with no token in `colors` (the token object is not edited).
export const GRAY_BORDER = "#ACAFAD";
export const FRAME_BORDER = "#858B87";
export const WHITE = "#FFFFFF";
// The meta rows' "|" on Manage Groups cards.
export const SEPARATOR_GRAY = "#CBCDCC";

export const interText = (size, lineHeight, weight = 400, letterSpacing = "0.25px") => css`
  color: ${colors.nightlyWoods500};
  font-family: Inter, sans-serif;
  font-size: ${size}px;
  font-weight: ${weight};
  letter-spacing: ${letterSpacing};
  line-height: ${lineHeight}px;
`;

export const marfaTitle = css`
  color: ${colors.nightlyWoods500};
  font-family: "ABC Marfa", sans-serif;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 32px;
  margin: 0;
`;

export const Message = styled.p`
  ${interText(16, 22)}
  margin: 0;
`;

export const VisuallyHidden = styled.span`
  border: 0;
  clip: rect(0 0 0 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`;

// Text button (Back, Try Again in the preview): 48 high, chevron or not, the
// label in one 4px frame.
export const TextButton = styled.button`
  align-items: center;
  align-self: flex-start;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: inline-flex;
  height: 48px;
  padding: 0 16px 0 8px;

  & > span {
    ${interText(18, 26)}
    color: ${colors.blue700};
    padding: 0 4px;
  }

  &:hover > span {
    text-decoration: underline;
  }
`;

// Figma "Button/Secondary": white, 1px blue, radius 8, label in one 4px frame.
export const SecondaryButton = styled.button`
  align-items: center;
  background: ${WHITE};
  border: 1px solid ${colors.blue500};
  border-radius: 8px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-flex;
  height: 48px;
  justify-content: center;
  padding: 0 15px;

  & > span {
    ${interText(18, 26, 700)}
    color: ${colors.blue500};
    padding: 0 4px;
    white-space: nowrap;
  }

  &:hover:not(:disabled) {
    background: ${colors.blue50};
  }
`;

// A native select drawn as Figma's closed state, the chevron laid over it.
export const SelectFrame = styled.span`
  display: inline-flex;
  position: relative;

  & > svg {
    pointer-events: none;
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-50%);
  }
`;

export const nativeSelect = (width, height) => css`
  ${interText(14, 20, 400, "0")}
  appearance: none;
  background: ${WHITE};
  border: 1px solid ${colors.blue300};
  border-radius: 6px;
  box-sizing: border-box;
  cursor: pointer;
  height: ${height}px;
  margin: 0;
  padding: 7px 11px;
  width: ${width}px;

  &:disabled {
    cursor: default;
  }
`;
